import React from 'react'

const NameLesson = () => {
  return (
    <div>
        <h1 className='namelesson'>"TERMODINAMIKA VA ISSIQLIK UZATISH ASOSLARI" </h1>
        <h2 className='italic'>fanidan laboratoriya mashg‘ulotlarini bajarish uchun o‘quv qo‘llanma</h2>
  
    </div>
  )
}

export default NameLesson